<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="23cm"
      :fullscreen="fullscreen"
      :persistent="true">
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">打印建帐通知单</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <div id="printMe" class="prt-wrapper">
          <div v-for="(it, ind) in sortedProjIncoItems" :key="ind+1">

            <h2 class="x-center">科技计划项目 建帐通知单</h2>
            <p class="x-single-line x-right">经费单位：人民币元</p>
            <table cellspacing="0">
              <tr>
                <td class="x-center" style="width: 6em">项目名称</td>
                <td colspan="5">
                  {{ it.project.name }}
                </td>
              </tr>
              <tr>
                <td class="x-center">项目类别</td>
                <td style="min-width: 10em">
                  {{ it.project.type ? it.project.type.name : '' }}
                </td>
                <td class="x-center" style="width: 6em">项目编号</td>
                <td style="width: 9em">
                  {{ it.project.code }}
                </td>

                <td class="x-center" style="width: 5em">批准号</td>
                <td style="width: 9em">
                  {{ it.project.number }}
                </td>

              </tr>
              <tr>
                <td class="x-center">承担单位</td>
                <td>{{ it.project.department ? it.project.department.name : '' }}</td>
                <td class="x-center">项目负责人</td>
                <td colspan="3">{{ it.project.leaderName }} {{ it.project.leaderPhone || '' }}</td>
              </tr>
              <tr>
                <td class="x-center">拔款单位</td>
                <td colspan="5">{{ it.income.drawee }}</td>
              </tr>
              <tr>
                <td class="x-center">到款日期</td>
                <td>{{ it.income.paymentDate }}</td>
                <td class="x-center">到款次数</td>
                <td>{{ it.income.serialNum }}（{{ it.income.property }}）</td>
                <td class="x-center">建帐方式</td>
                <td class="" v-if="it.income.kyYwTrans">
                  自动<br/>
                  {{ it.income.kyYwTrans.pch }}
                  <!--                              <br/>-->
                  <!--                              <span v-if="item.kyYwTrans.iscl" style="color: steelblue">财务已处理</span>-->
                  <!--                              <span v-else>财务未处理</span>-->
                </td>
                <td class="" v-else>手工</td>
              </tr>
              <tr>
                <td class="x-center">合同经费</td>
                <td >{{ it.project.contractAmounts | currency }}</td>
                <td class="x-center">项目开始日期</td>
                <td>{{ it.project.startDate}}</td>
                <td class="x-center">项目结束日期</td>
                <td>{{ it.project.finishDate}}</td>
              </tr>
              <tr>
                <td class="x-center">到款经费</td>
                <td>{{ it.income.amount | currency }}</td>
                <td class="x-center">研究经费</td>
                <td >{{ it.income.researchFund | currency }}</td>
                <td class="x-center">资金性质</td>
                <td >{{ it.zjlx}}</td>
              </tr>

              <!--
              <td class="x-center" v-if = "it.project.type.category == 'zx'">
                财政<br/>
              </td>
              <td class="" v-else>非财政</td>-->

              <tr>
                <td class="x-center">序号</td>
                <td>项目</td>
                <td class="x-center">比例</td>
                <td class="x-center">经费卡</td>
                <td colspan="2" class="x-right">金额</td>
              </tr>
              <tr v-for="(inc, idx) in it.income.fundItems" :key="idx+1">
                <td class="x-center">
                  {{ idx + 1 }}
                </td>
                <td class="x-left">
                  <span :style="{paddingLeft:(inc.level-1) + 'em'}">{{ inc.partitionName }}</span>
                </td>
                <td class="x-center">
                  {{ Math.round(Number(inc.percent * 1)) }}%
                </td>
                <td class="x-center">
                  {{ inc.cardNumber }}
                </td>
                <td class="x-right" colspan="3">{{ inc.amount | currency }}
                </td>
              </tr>

              <tr>
                <td class="x-center">填表人</td>
                <td>{{ it.income.userName }}</td>
                <td class="x-center">备注</td>
                <td >{{ it.income.note }}</td>
                <td class="x-center">预算管理</td>
                <td class="x-center">{{it.buget}}</td>
              </tr>
              <tr>
                <td class="x-center" style="padding-top: 1.5em;padding-bottom: 1.5em;">科学技术院签章</td>
                <td>&nbsp;</td>
                <td class="x-center">财务处签章</td>
                <td colspan="3">&nbsp;</td>
              </tr>
            </table>
            <div style="page-break-after: always"/>
          </div>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn flat color="primary" @click.native="visible=false">关闭</v-btn>
        <v-btn v-print="'#printMe'" :disabled="printDisabled" color="primary">
          {{ printDisabled ? '正在生成数据' : '打印'}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapGetters} from 'vuex'

import mixin from '@/mixin'

const baseURI = '/api/proj/cw_lkxx'
const IncoURI = '/api/proj/fund/income'
const projURI = '/api/proj/project'
const getBugetUri = '/api/proj/project/buget';


export default {
  mixins: [mixin.view(baseURI)],
  props: ['value', 'dbid', "project"],

  data() {
    return {
      item: {
        "partition": {}
      },

      projIncomes: [],

      headers: [
        {text: '#', sortable: false, value: 'rank', width: 18},
        {text: '拆分项目名称', sortable: false, value: 'name'},
        {text: '经费百分比', sortable: false, value: 'percent'},
        {text: '金额（元）', sortable: false, value: 'note', width: 230},
      ],

      projIncoItems: [],
      printDisabled: true,

      projFinishDate : '',
      curDate : '',
      nextDate : '',
      lastDate : '',
      tyear : '',
      tmonth : '',
      tday : '',
      msg: ''
    }
  },
  computed: {
    proj() {
      return this.project || {};
    },
    sortedProjIncoItems() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.projIncoItems.sort(
          (a, b) => {
            if (a.project['number'] < b.project['number']) {
              return -1;
            }
            else if (a.project['number'] > b.project['number']) {
              return 1;
            }
            else {
              return 0
            }
          })
      return this.projIncoItems
    },
    ...mapGetters([
      'authenticated',
      'name'
    ])
  },
  methods: {
    getfinishdate(tDate) {
      const vm = this
      if (tDate) {
        vm.projFinishDate = tDate
        vm.curDate = new Date(tDate)
        vm.nextDate = vm.curDate.setYear(vm.curDate.getFullYear() + 2)
        vm.lastDate = new Date(vm.nextDate)
        vm.tyear = vm.lastDate.getFullYear()
        vm.tmonth = vm.lastDate.getMonth() + 1
        vm.tday = vm.lastDate.getDate()
        vm.tmonth = vm.tmonth < 10 ? "0" + vm.tmonth : vm.tmonth
        vm.tday = vm.tday < 10 ? "0" + vm.tday : vm.tday
        return `${vm.tyear}-${vm.tmonth}-${vm.tday}`
      }
    },
    afterGetData(data) {
      let tBuget = ''
      const vm = this
      // 清空原有结果
      vm.projIncoItems = []
      vm.getBugetFlag = []
      vm.printDisabled = true
      //此次的data由Mixin.View调用FundCwLkxxServlet的byDbid获取
      if (data && data.claimItems) {
        //获取资金类型,并在后续const it中将其构造到每笔项目到款中
        const zjlx = data.lkbz
        data.claimItems.forEach(it => {
          vm.ms = `获取：${it.name}， ……`;
          this.axios.all([
            this.axios.get(`${IncoURI}/by/${it.pznm}/${it.flbh}/${it.projectId}`),
            this.axios.get(`${projURI}/${it.projectId}`),
            this.axios.get(`${getBugetUri}/${it.projectId}`)
          ]).then(this.axios.spread((inco, proj, buget) => {
            if (buget.data.length > 0) {
              tBuget = "科目管理"
            } else {
              tBuget = "余额管理"
            }
            const it = {"income": inco.data, "project": proj.data, "buget": tBuget, "zjlx": zjlx}
            vm.projIncoItems.push(it)
            vm.getBugetFlag.push(it.project.dbid)
            if (vm.projIncoItems.length === data.claimItems.length)
              vm.printDisabled = false
          }))
        })
      }
    }
  }
}
</script>

